<div>
  @switch (deviceInfoView) {
    @case (DeviceInfoViewEnum.DeviceDetails) {
      <div class="d-info">
        <div class="d-flex">
          <div class="heading-text">
            <span class="title-indicator">
              {{ deviceInfo?.name }}
          <span [ngClass]="{
                            'inactive-btn': !deviceInfo?.status,
                            'active-btn': $safeNavigationMigration(deviceInfo?.status)
                        }">
                {{ (deviceInfo?.status ? "Active" : "Inactive") | translate}}
              </span>
            </span>
          </div>
          <div class="d-info-icons">
            <div>
              <span class="battery-percentage">
                @if (batteryInfo.imgSrc) {
                  <img class="battery-img" [src]="batteryInfo.imgSrc"
                    [title]="batteryInfo.tooltip">
                }
              </span>
            </div>
          </div>
        </div>
        <hr />
        <div class="d-info-body">
          <div class="device-info-row">
            <span>{{'Last Active Date' | translate}}</span>
            @if (deviceInfo?.lastUpdated) {
              <span class="info-value-pr">
                {{ $safeNavigationMigration(deviceInfo?.lastUpdated) | dateFormat : dateFormatService.dateToTimeFormat }}
                <span class="bullet">•</span>
                {{ $safeNavigationMigration(deviceInfo?.lastUpdated) | dateFormat : dateFormatService.shortDateFormat }}
              </span>
            }
          </div>
          <div class="device-info-row">
            <span>{{'Sampling Frequency' | translate}}</span>
            @if (deviceInfo?.samplingFrequency) {
              <span class="info-value-pr">
                {{ deviceInfo?.samplingFrequency }} sec
              </span>
            }
          </div>
          <div class="device-info-row">
            <span>{{'IMEI Number / MAC ID' | translate}}</span>
            <span class="info-value-pr">{{ deviceInfo?.imeI_No }}</span>
          </div>
          <div class="device-info-row">
            <span>{{'Firmware Version' | translate}}</span>
            <span class="info-value-pr">{{ deviceInfo?.firmware }}</span>
          </div>
          <div class="device-info-row link-cursor" (click)="switchView(DeviceInfoViewEnum.ParameterMeasured)">
            <span>{{'Parameter Measured' | translate}}</span>
            <span class="material-icons float-right">chevron_right</span>
          </div>
          <div class="device-info-row d-block cursor-pointer" (click)="switchView(DeviceInfoViewEnum.DeviceHistory)">
            <div>
              <span>{{'Endpoint' | translate}}</span>
              <span class="material-icons float-right cursor-pointer">chevron_right</span>
            </div>
            <hr />
            <span class="info-value-pr grey-text">
              {{
              deviceInfo?.endPointName
              ? deviceInfo?.endPointName
              : ("No endpoint available" | translate)
              }}
            </span>
          </div>
          <div class="d-flex py-2 justify-content-end">
            <button class="btn py-0 transparent-btn bordered-btn" (click)="openAddCalibrationPopup()">
              {{ 'Add Calibration' | translate }}
            </button>
          </div>
          <div class="device-info-row d-block cursor-pointer" (click)="switchView(DeviceInfoViewEnum.CalibrationHistory)">
            <div>
              <span>{{'Maintenance' | translate}}</span>
              <span class="material-icons float-right">chevron_right</span>
            </div>
            <hr />
            <div class="device-info-row p-0">
              <span>{{'Last Calibrated' | translate}}</span>
              <span class="info-value-pr">{{
                deviceInfo?.lastCalibratedFormatted
              }}</span>
            </div>
            <div class="device-info-row p-0">
              <span>{{'Calibration Due On' | translate}}</span>
              <span class="info-value-pr">{{
                deviceInfo?.nextCalibrationFormatted
              }}</span>
            </div>
          </div>
          <div class="device-info-row">
            <span>{{'Installation Date' | translate}}</span>
            <span class="info-value-pr">{{
              $safeNavigationMigration(deviceInfo?.installationDateFormatted) | dateFormat : dateFormatService.shortDateFormat
            }}</span>
          </div>
        </div>
      </div>
    }
    @case (DeviceInfoViewEnum.DeviceHistory) {
      <app-device-history [filterValue]="selectedDeviceData.name"
        (hideHistoryView)="switchView(DeviceInfoViewEnum.DeviceDetails)">
      </app-device-history>
    }
    @case (DeviceInfoViewEnum.CalibrationHistory) {
      <app-device-calibration-history
        [filterValue]="selectedDeviceData.name" (hideHistoryView)="switchView(DeviceInfoViewEnum.DeviceDetails)">
      </app-device-calibration-history>
    }
    @case (DeviceInfoViewEnum.ParameterMeasured) {
      <div class="d-info">
        <div class="d-flex w-100">
          <div class="heading-text">
            <span class="title-indicator">
              <span class="material-icons cursor-pointer" (click)="switchView(DeviceInfoViewEnum.DeviceDetails)">
                chevron_left
              </span>
              <span class="pl-2 super-align">{{'Parameters Measured' | translate}}</span>
            </span>
          </div>
        </div>
        <hr class="mt-0"/>
        <div class="d-info-body">
          @for (parameter of deviceInfo?.parameters; track trackById($index, parameter)) {
            <div class="device-info-row">
              <span>{{ parameter.name }}</span>
            </div>
          }
        </div>
      </div>
    }
  }
</div>